export interface ProjectTasks {
    projectID: number,
    tasks?: Task[],
    intermediates?: Intermediate[]
}

export interface Task {
    name: string,
    originalAmount: number,
    description?: string
}

export interface Intermediate {
    name: string,
    tasks?: Task[],
    intermediate?: Intermediate[]
}

export enum UploadType {
    PaintSF = "/admin/projectTasks/uploadPaintSFExcelApplyChanges",
    PaintMF = "/admin/projectTasks/uploadPaintMFExcelApplyChanges",
    PaintMFV1 = "/admin/projectTasks/uploadPaintMFExcelApplyChangesV1",
    DrywallSF = "/admin/projectTasks/uploadDrywallSFExcelApplyChanges",
    DrywallMF = "/admin/projectTasks/uploadDrywallMFExcelApplyChanges",
    Piece2020 = "/admin/2020ph/projectTasks/uploadPieceCsvApplyChanges",
    UpfPiecePdf = "/admin/upf/projectTasks/uploadPiecePdfApplyChanges",
}

export interface ComparisonTask extends Task {
    status: 'new' | 'removed' | 'updated' | 'unchanged' | 'claimed';
    originalTaskAmount?: number;
    remainingTaskAmount?: number;
    newAmount?: number;
}

export interface ComparisonIntermediate extends Omit<Intermediate, 'tasks'> {
    status?: 'new' | 'removed' | 'updated' | 'unchanged';
    tasks?: ComparisonTask[];
    intermediate?: ComparisonIntermediate[];
    safeToRemove?: boolean;
}

export interface ProjectTasksComparison {
    projectID: number;
    hasExistingTasks: boolean;
    tasks?: ComparisonTask[];
    intermediates?: ComparisonIntermediate[];
    claimedTasksCount: number;
    summary: {
        additions: number;
        removals: number;
        updates: number;
        unchanged: number;
        claimed: number;
        intermediatesAdded: number;
        intermediatesRemoved: number;
    };
}

export interface HourlyCostCode {
    accountCodeID: number;
    altAccountCodeID: string;
    name: string;
    description?: string;
    status: string;
}

export interface HourlyCostCodesPhase {
    phase: string;
    costCodes: HourlyCostCode[];
}

export interface HourlyCostCodesComparison {
    hourlyCostCodes: HourlyCostCodesPhase[];
    summary: {
        unchanged: number;
        removals: number;
        additions: number;
    };
}

export interface PieceComparisonResponse {
    projectID: number;
    hasExistingTasks: boolean;
    altProjectID?: string;
    projectName?: string;
    projectTasksComparison: ProjectTasksComparison;
    hourlyCostCodesComparison?: HourlyCostCodesComparison;
}